import type { ReactNode } from 'react';

interface IFormActionsProps {
  children: ReactNode;
}

/**
 * Centering wrapper for the action button(s) at the bottom of a form.
 * Provides consistent spacing between the form content and its submit area.
 */
export const FormActions = ({ children }: IFormActionsProps) => (
  <div style={{ display: 'flex', justifyContent: 'center', marginTop: 50 }}>
    {children}
  </div>
);
